import { Tabs, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { BoxShopInventoryView } from "@/modules/boxShop/components/boxShopInventoryView"
import { BoxShopShoppingView } from "@/modules/boxShop/components/boxShopShoppingView"
import { PackageIcon, ShoppingBagIcon } from "lucide-react"
import { Activity, startTransition, Suspense, useState } from "react"
import { word } from "@/modules/core/utils/i18n"
import { useBoxStaffPermission } from "@/modules/boxStaff/hooks/useBoxStaffPermissions"
import { BoxStaffPermissions } from "@/modules/boxStaff/gateway/boxStaffDto"
import { LoadingSpinner } from "@/modules/ui/components/loading"

export function BoxShopLayout() {
  const [activeIndex, setActiveIndex] = useState("0")
  const canSeeInventory = useBoxStaffPermission(BoxStaffPermissions.SEE_INVENTORY)

  function selectTab(index: string) {
    startTransition(() => {
      setActiveIndex(index)
    })
  }

  return (
    <>
      <Tabs
        value={activeIndex}
        onValueChange={(value) => {
          selectTab(String(value))
        }}
        className="flex w-full flex-col"
      >
        <TabsList variant="default" className="mx-0 w-fit">
          <TabsTrigger variant="default" value="0">
            <ShoppingBagIcon />
            {word("boxShop.layout.tabs.shopping")}
          </TabsTrigger>
          {canSeeInventory && (
            <TabsTrigger variant="default" value="1">
              <PackageIcon />
              {word("boxShop.layout.tabs.inventory")}
            </TabsTrigger>
          )}
        </TabsList>
      </Tabs>

      <Activity mode={activeIndex === "0" ? "visible" : "hidden"}>
        <Suspense fallback={<LoadingSpinner />}>
          <BoxShopShoppingView />
        </Suspense>
      </Activity>
      {canSeeInventory && (
        <Activity mode={activeIndex === "1" ? "visible" : "hidden"}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxShopInventoryView />
          </Suspense>
        </Activity>
      )}
    </>
  )
}
